import { reactive, readonly, computed, toRaw} from 'vue'
//import axios from 'axios'
import jwt_decode from 'jwt-decode'
import { socketConnect } from './components/socketConnection'
import {format} from 'date-fns'
import api from './api'
import CryptoJS from 'crypto-js';
const broadcastEncryptionKey = 'digitallaborsolutionsIsEncryptingData'
const broadcastOriginId = 'dlstracker-8675309'

const encrypt = (data)=>{ 
  return CryptoJS.AES.encrypt(JSON.stringify(data), broadcastEncryptionKey ).toString();
}

const decrypt = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, broadcastEncryptionKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

document.addEventListener('visibilitychange',()=>{
  if(document.visibilityState === 'visible') {
    console.log('App is active. Checking token status...')
    checkTokenExpiry()
  }
})


// State
  const state = reactive({
    auth: {
      loggedIn: false,
      name: '',
      email: '',
      role: {},
      token: '',
      refreshToken:'',
      organization: '',
      timesheet:false,
      onSchedule:false,
      fourDayWeek:false
    },
    // A System Admin's planned sign-out (taking the server down): when it ends, by this tab's clock, and who started it.
    plannedSignOut: null,
    systemStatus: {
      dbConnection: false,
      wsConnection: false,
      // Default true: don't flash a "degraded" indicator on app boot before the initial
      // /api/v1/ai/status fetch lands or the first socket event arrives. The probe will
      // correct it within seconds if the AI provider is actually down.
      aiConnection: true
    },
    logoutError: false,
    sideBarOpen: false,
    logOutFlag: false,
    modalBlock:false,
    darkModeState:true,
    scrollBarState:false,
    aiAssistCollapsed:false,
    // Projects list: search and scroll last for the session. Its saved view (tab, grouping, sort, Mine) is kept per
    // user in localStorage by ViewProjects.vue.
    projectListSettings:{
      projectNumberFilter:'',
      scrollTop:{install:0,warehouse:0}
    },
    appError: null
  })


// Getters
  const authenticated = computed(() => state.auth)
  const appStatus = computed(() => state.systemStatus)
  const darkState = computed(()=>state.darkModeState)
  const scrollState = computed(()=>state.scrollBarState)
  const aiAssistCollapsedState = computed(()=>state.aiAssistCollapsed)
  const isLogoutError = computed(() => state.logoutError)
  const sideBar = computed(() => state.sideBarOpen)
  const initials = computed(() => {
    if (state.auth.name.indexOf(" ") > 0) {
      let nameArray = state.auth.name.split(" ")
      let nameArraylength = nameArray.length
      return nameArray[0].charAt(0) + nameArray[nameArraylength - 1].charAt(0)
    } else return state.auth.name.charAt(0)
  })
  const loggingOut = computed(() => state.logOutFlag)
  const expiration = computed(() => {
    if (state.auth.token) {
      const decodedToken = jwt_decode(state.auth.token)
      return decodedToken.exp
    } else return ''
  })
  const isModalBlocked = computed(()=>state.modalBlock)
  const appError = computed(() => state.appError)
  const projectViewSettings = computed(()=>state.projectListSettings)

//Auth Broadcast Channel
  const authChannel = new BroadcastChannel('auth-channel')

  // One user per browser. A tab that is reloading to sign out must not answer auth requests, or a tab
  // booting at the same moment could adopt the old user and announce it back.
  let signingOut = false
  let pendingAuthResolve = null
  // The user of the latest real sign-in heard on the channel. A booting tab can hear it before a late
  // answer from the previous user's tab, and must not adopt that answer.
  let lastSignInUserId = null

  const signOutTab = ()=>{
    signingOut = true
    window.location.reload()
  }

  // A page restored from the back/forward cache missed the channel while it was away and may hold a
  // previous user. Reload it so it adopts whoever is signed in now.
  window.addEventListener('pageshow',(event)=>{
    if(event.persisted && state.auth.loggedIn) {signOutTab()}
  })

  authChannel.onmessage = (event)=>{
    if(event.data?.type === 'auth_request') {
      console.log('Received auth request.')
      if(authenticated.value.loggedIn && !signingOut) {
        console.log('Sending Authentication to Requestor.')
        const encryptedAuth = encrypt({
          ...toRaw(authenticated.value),
          timestamp: Date.now(),
          originId:broadcastOriginId
        });
        authChannel.postMessage({type:'auth',auth:encryptedAuth})
      }
    } else if (event.data?.type === 'auth') {
      try {
        if(!authenticated.value.loggedIn && !window.location?.pathname?.includes('/external')) {
          
            const decryptedAuth = decrypt(event.data.auth);
            const isLatestUser = !lastSignInUserId || String(decryptedAuth?._id) === lastSignInUserId
            if(decryptedAuth?.originId === broadcastOriginId && Date.now() - decryptedAuth.timestamp < 5000 && isLatestUser) {
              login(decryptedAuth, {fromOtherTab:true});
              pendingAuthResolve?.()
            }
        }
      } catch (error) {
        console.error('Failed to decrypt auth data:', error);
      }
    } else if (event.data?.type === 'other-tab-login') {
      if(event.data.userId) {lastSignInUserId = String(event.data.userId)}
      if(authenticated.value.loggedIn) {
        if(event.data.userId && String(event.data.userId) !== String(authenticated.value._id)) {
          console.log('Another user signed in on this browser. Signing out.')
          signOutTab()
        }
      } else if (window.location.pathname === '/login' || pendingAuthResolve) {
        // Not signed in, on the sign-in page or still booting toward it: ask again, so a sign-in that lands during
        // the 300ms wait is picked up rather than missed.
        authChannel.postMessage({type:'auth_request'})
      }
    } else if (event.data?.type === 'logout' && window.location.pathname !== '/login' && !window.location?.pathname?.includes('/external')) {
      // A stale tab of a previous user signing out must not sign out the current one. Nor must a tab ending an
      // OLDER sign-in of this user (a password reset signs the old sessions out while this tab signs in anew).
      const mySignIn = authenticated.value.token ? parseJwt(authenticated.value.token)?.authTime : null
      const newerSignIn = event.data.authTime && mySignIn && mySignIn > event.data.authTime
      if((!event.data.userId || String(event.data.userId) === String(authenticated.value._id)) && !newerSignIn) {
        // Stop answering auth_request at once: a "Leave site?" prompt can hold the reload open
        signOutTab()
      }
    }
  }

  // Resolves as soon as another tab's answer signs this tab in, else after 300ms. Resolves null
  // either way; callers read authenticated.loggedIn.
  const requestAuth = ()=>{
    return new Promise((resolve) => {
    console.log('Requesting Authentication.')
    const done = ()=>{
      if(pendingAuthResolve === done) {pendingAuthResolve = null}
      resolve(null)
    }
    pendingAuthResolve = done
    setTimeout(done, 300);
    authChannel.postMessage({type:'auth_request'})
    })
  }

  const checkTokenExpiry = ()=>{
    const token = authenticated.value?.token
    if (!token) {
      console.warn('No token found. User might not be logged in.');
      return;
    }

    const tokenPayload = parseJwt(token)

    if (!tokenPayload || !tokenPayload.exp) {
      console.error('Invalid token or missing expiration.');
      return;
    }

    const expirationTime = tokenPayload.exp * 1000; // Convert to milliseconds
    const now = Date.now();

    if (now >= expirationTime) {
        // Expired while the laptop slept (page timers stop during sleep): renew it, and sign out only if that fails.
        console.warn('Token has expired. Renewing...');
        refreshNow().then(result => { if (result === 'refused') logout({ serverEnded: true }) })
    } else if (now >= expirationTime - 60000) { // 1 minute before expiration
        console.log('Token is about to expire. Refreshing...');
        startTokenRefresh(); // Refresh the token
    }
  }

  // One renewal at a time, shared by the refresh timer, the expiry check, a request that came back with an expired
  // token and the socket. 'renewed' | 'refused' (the server ended the sign-in: sign out) | 'unavailable' (no network
  // yet after a wake, or a server error: keep the session, the minute check tries again).
  let refreshInFlight = null
  const refreshNow = () => {
    if (refreshInFlight) {return refreshInFlight}
    refreshInFlight = (async () => {
      try {
        const res = await api.post('auth/refreshToken', { refreshToken: authenticated.value?.refreshToken })
        if (res.data?.data?.token && res.data?.data?.refreshToken) {
          state.auth.token = res.data.data.token
          state.auth.refreshToken = res.data.data.refreshToken
          startTokenRefresh()
          return 'renewed'
        }
        return 'unavailable'
      } catch (err) {
        console.error('Token renewal failed:', err.response?.data?.error || err.message)
        const status = err.response?.status
        return status === 400 || status === 401 || status === 403 || status === 404 ? 'refused' : 'unavailable'
      } finally {
        refreshInFlight = null
      }
    })()
    return refreshInFlight
  }

  // Page timers don't run while the computer sleeps, so the refresh timer can miss the expiry. A wall-clock check
  // every minute catches it within a minute of waking.
  setInterval(() => { if (state.auth.loggedIn && !signingOut) {checkTokenExpiry()} }, 60000)

// Mutations
  const setTheme = (value) =>{
    value === 'dark'
    ? state.darkModeState = true
    : state.darkModeState = false
    // Keep state.auth in sync so a later cross-tab auth broadcast carries the current theme.
    if(state.auth?.loggedIn) { state.auth.darkModeState = state.darkModeState ? 'dark' : 'light' }
  }

  const setThemefromProfile = (value)=>{
    value === 'dark'
    ? state.darkModeState = true
    : state.darkModeState = false

    localStorage.setItem('theme', state.darkModeState ? 'dark' : 'light')
  }

  const toggleTheme = ()=>{
    state.darkModeState = !state.darkModeState
    const theme = state.darkModeState ? 'dark' : 'light'
    // Keep state.auth in sync so the cross-tab auth broadcast (login -> setThemefromProfile)
    // carries the current theme rather than the stale value loaded at login.
    if(state.auth?.loggedIn) { state.auth.darkModeState = theme }
    localStorage.setItem('theme', theme)
    persistThemeSettings({'darkModeState':theme })
  }

  const setScrollBars = (value)=>{
    value === 'true' || value === true
    ? state.scrollBarState = true
    : state.scrollBarState = false
  }

  const setScrollBarsfromProfile = (value)=>{
    value ? state.scrollBarState = true : state.scrollBarState = false
    localStorage.setItem('scrollBars', state.scrollBarState ? 'true' : 'false')
  }

  const toggleScrollBars = ()=>{
    state.scrollBarState = !state.scrollBarState
    localStorage.setItem('scrollBars', state.scrollBarState ? 'true' : 'false')
    persistThemeSettings({'scrollBarState':state.scrollBarState})
  }

  const setAiAssistCollapsed = (value)=>{
    value === 'true' || value === true
    ? state.aiAssistCollapsed = true
    : state.aiAssistCollapsed = false
  }

  const setAiAssistCollapsedfromProfile = (value)=>{
    value ? state.aiAssistCollapsed = true : state.aiAssistCollapsed = false
    localStorage.setItem('aiAssistCollapsed', state.aiAssistCollapsed ? 'true' : 'false')
  }

  const toggleAiAssistCollapsed = ()=>{
    state.aiAssistCollapsed = !state.aiAssistCollapsed
    localStorage.setItem('aiAssistCollapsed', state.aiAssistCollapsed ? 'true' : 'false')
    persistThemeSettings({'aiAssistCollapsed':state.aiAssistCollapsed})
  }

  const login = function (user, {fromOtherTab = false} = {}) {
    // A code step this tab saved (LoginDialog) ends with any sign-in, including one taken from another tab
    try { sessionStorage.removeItem('signInChallenge') } catch { /* storage blocked: nothing to clear */ }

    // Emit event to close existing socket, needed if relogin before token expiration.
    // Listener is in ./components/socketConnection.
    let event = new Event('closeExistingSocket')
    dispatchEvent(event)
    state.auth = {loggedIn:true,...user}
    sessionStorage.setItem("loggedIn", true)
    if(!user.fourDayWeek) {state.auth.fourDayWeek = false}

    if(authenticated.value.token && authenticated.value.refreshToken) {
      startTokenRefresh()
    }

    setThemefromProfile(state.auth.darkModeState || 'dark')
    setScrollBarsfromProfile(state.auth.scrollBarState || false)
    setAiAssistCollapsedfromProfile(state.auth.aiAssistCollapsed || false)

    // Only a real sign-in announces itself. A tab adopting a sign-in from another tab re-announcing it
    // could sign out the tab of a user who signed in since.
    if(!fromOtherTab) {authChannel.postMessage({type:'other-tab-login', userId:state.auth._id})}


    //if login triggered, db connection is true.
    state.systemStatus.dbConnection = true


    // connect websocket, function in ./components/socketConnection.
    console.log('Connecting WebSocket')
    socketConnect(state.auth.token)
  }

  let refreshTimer = null

  const startTokenRefresh = () => {
    if (refreshTimer) {clearTimeout(refreshTimer)}

    if (authenticated.value.token && authenticated.value.refreshToken) {
        const tokenPayload = parseJwt(authenticated.value.token);

        if (!tokenPayload || !tokenPayload.exp) {
            console.error('Invalid token payload or missing expiration');
            return;
        }

        const refreshTime = (tokenPayload.exp * 1000) - Date.now() - 60000; // 1 minute before expiration
        console.log('Initiating Token refresh process.');

        // A renewal that can't reach the server is retried by the minute check, so no retry loop here.
        const attemptRefresh = async () => {
            console.log('Attempting Token Refresh.');
            if (await refreshNow() === 'refused') {logout({ serverEnded: true })}
        };

        refreshTimer = setTimeout(attemptRefresh, Math.max(refreshTime, 0)); // Schedule initial refresh attempt
    }
};

  const updateLocalAccount = (user)=>{
    if(typeof user === 'object' && authenticated.value.loggedIn) {
      state.auth = {loggedIn:true,...user}
    }
  }

  const loginAnon = (secureCode,accessCode)=>{
    let event = new Event('closeExistingSocket')
    dispatchEvent(event)
    state.systemStatus.dbConnection = true
    console.log('Attempting Anonymous WebSocket Connection.')
    socketConnect(null,secureCode,accessCode)
  }

  // A user's own Log Out signs out every tab of this browser. A sign-out the SERVER ended (password reset, lock,
  // a refused renewal) carries the sign-in it ended, so a tab holding a newer sign-in of the same user keeps it.
  // The menu calls this straight from a click, so the option is an explicit flag a click event can't match.
  const logout = async (options) => {
    signingOut = true
    try { sessionStorage.removeItem('signInPrompts'); sessionStorage.removeItem('signInChallenge') } catch { /* storage blocked: nothing to clear */ }
    window.location.reload()
    const serverEnded = options?.serverEnded === true
    if(state.auth._id) {authChannel.postMessage({type:'logout', userId:state.auth._id, authTime: serverEnded && state.auth.token ? parseJwt(state.auth.token)?.authTime : null})}
  }


  // Sets value of server connection to DB and Browser Websocket connection to server.
  // Displayed as red/green in App.vue. 'ai' tracks AI provider reachability — driven by
  // the server-side health probe (broadcast via ai_status socket event) AND the initial
  // /api/v1/ai/status fetch on app mount.
  const setAppStatus = (type, status) => {
    if (type == 'db') { state.systemStatus.dbConnection = status }
    if (type == 'ws') { state.systemStatus.wsConnection = status }
    if (type == 'ai') { state.systemStatus.aiConnection = status }
  }

  // The server sends the time left, not the end time, so this tab's clock being off doesn't move the countdown.
  const plannedSignOut = computed(() => state.plannedSignOut)
  const setPlannedSignOut = (plan) => {
    state.plannedSignOut = typeof plan?.remainingMs === 'number' ? { endsAt: Date.now() + plan.remainingMs, byUserId: plan.byUserId } : null
  }

  const toggleSideBar = () => {
    state.sideBarOpen = !state.sideBarOpen
  }

  const closeSideBar = () => {
    state.sideBarOpen = false
  }

  const convertDate = async (val) =>{
    let selectedDate = new Date(val)
    let convertedDate =  new Date(selectedDate.getTime() + selectedDate.getTimezoneOffset() *60000)
    return convertedDate
  }

  const distanceBetweenPoints = (lon1,lat1,lon2,lat2,unit)=> {
    if ((lat1 == lat2) && (lon1 == lon2)) {
      return 0;
    }
    else {
      var radlat1 = Math.PI * lat1/180;
      var radlat2 = Math.PI * lat2/180;
      var theta = lon1-lon2;
      var radtheta = Math.PI * theta/180;
      var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = dist * 180/Math.PI;
      dist = dist * 60 * 1.1515;
      if (unit=="K") { dist = dist * 1.609344 }
      if (unit=="N") { dist = dist * 0.8684 }
      return dist;
    }
  }

  const formatDate = (date)=> {
    return format(new Date(date), 'ccc MMM dd, yyyy')
  }

  const sendChangeEvent = (type,data)=>{
      let changeEvent = new CustomEvent("local_data_change",{detail:{type,data}} );
      dispatchEvent(changeEvent);
  }

  const openDetails = (target) =>{
    if(target.nextElementSibling) {
      target.nextElementSibling.classList.toggle('hidden')
    }
  }

  const setModalBlocked = (val)=>{
    state.modalBlock = val
  }

  const setAppError = (err) => {
    state.appError = err instanceof Error ? err : (err ? String(err) : null)
  }

  const clearAppError = () => {
    state.appError = null
  }

  const setProjectListSettings = (key,value)=>{
    state.projectListSettings[key] = value
  }

  const persistThemeSettings = async (body)=>{
    if(authenticated.value?._id) {
      await api
      .put('auth/updateme',body)
      .then((res)=>{
          res.data?.data && typeof res.data.data === 'object'
          ? sendChangeEvent('themeSettings',{userId:res.data?.data._id,...body})
          : null
        }
      )
      .catch((err)=>{
        console.error(err.response?.data?.error || err.message)
      })
    }
  }

  const parseJwt = (token)=> {
    try {
        if (!token) {
            throw new Error('Token is undefined or null');
        }

        const base64Url = token.split('.')[1];
        if (!base64Url) {
            throw new Error('Invalid JWT format');
        }

        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                .join('')
        );
        return JSON.parse(jsonPayload);
    } catch (error) {
        console.error('Failed to parse JWT:', error.message);
        return null; // Gracefully return null if parsing fails
    }
}

export default {
  state: readonly(state),
  expiration,
  authenticated,
  appStatus,
  initials,
  isLogoutError,
  sideBar,
  loggingOut,
  login,
  refreshNow,
  loginAnon,
  logout,
  //authOnRefresh,
  setAppStatus,
  plannedSignOut,
  setPlannedSignOut,
  toggleSideBar,
  closeSideBar,
  convertDate,
  distanceBetweenPoints,
  formatDate,
  sendChangeEvent,
  openDetails,
  isModalBlocked,
  setModalBlocked,
  appError,
  setAppError,
  clearAppError,
  darkState,
  scrollState,
  setTheme,
  toggleTheme,
  setScrollBars,
  toggleScrollBars,
  aiAssistCollapsedState,
  setAiAssistCollapsed,
  setAiAssistCollapsedfromProfile,
  toggleAiAssistCollapsed,
  projectViewSettings,
  setProjectListSettings,
  authChannel,
  requestAuth,
  updateLocalAccount
}

